// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import Router from 'vue-router'
import router from './router'
import store from './store'
import axios from 'axios'
import global from './global'
import api from './api'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import './assets/css/public.scss'

Vue.use(ElementUI)
Vue.use(Router)

Vue.prototype.axios = axios;
Vue.prototype.GLOBAL = global;
Vue.prototype.$api = api;

Vue.config.productionTip = false


// 全局路由构造函数，判断是否登录和要跳转到页面
router.beforeEach((to, from, next) => {
  const _this = this
  if (to.matched.some(m => m.meta.neddLogin)) {    // 需要登录
    if(window.localStorage.Authorization){
      next()
    } else if (to.path !== '/') {
      let token = window.localStorage.Authorization;
      if (token === 'null' || token === '' || token === undefined){
          next({path: '/'})
          ElementUI.Message.error('检测到您还未登录,请登录后操作！');
      }
    } else {
      next()
    }
  } else {   // 不需要登录
    next()
  }
})
//添加请求拦截器
axios.interceptors.request.use(
  config =>{
    if(localStorage.getItem('Authorization')){
      config.headers.common['Authorization'] = localStorage.getItem('Authorization')
    }
    return config;
  },
  error =>{
    //对请求错误做什么
    return Promise.reject(error);
  })

//http reponse响应拦截器
axios.interceptors.response.use(
  response =>{
    return response;
  },
  error=>{
    if (error && error.response) {
      switch (error.response.status) {
        case 400: error.message = '请求错误(400)' ; break;
        case 401: error.message = '未授权，请重新登录(401)';break;
        case 402: error.message = '402';break;
        case 403: error.message = '拒绝访问(403)'; ElementUI.Message.error('token失效，请重新登录');localStorage.clear();router.replace('/'); break;
        case 404: error.message = '请求出错(404)'; break;
        case 408: error.message = '请求超时(408)'; break;
        case 500: error.message = '服务器错误(500)'; break;
        case 501: error.message = '服务未实现(501)'; break;
        case 502: error.message = '网络错误(502)'; break;
        case 503: error.message = '服务不可用(503)'; break;
        case 504: error.message = '网络超时(504)'; break;
        case 505: error.message = 'HTTP版本不受支持(505)'; break;
        default: error.message = `连接出错(${error.response.status})!`;
      }
    }else{
      error.message = '连接服务器失败!'
    }
    return Promise.reject(error)
  })


/* eslint-disable no-new */
new Vue({
  el: '#app',
  store,
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js